module.exports = __webpack_public_path__ + "img/back_active1.649fee2b.png";